class SearchSlider extends HTMLElement {
  constructor() {
    super();
    this.slider = null;
    this.sliderOptions = {};
  }

  connectedCallback() {
    this.initSlider();
  }

  initSlider() {
    if (!this.querySelector('[data-slider]')) return;

    this.sliderOptions = {
      autoHeight: true,
      calculateHeight: true,
      slidesPerView: 1.5,
      spaceBetween: 5,
      centeredSlides: true,
      loop: true,
    };

    this.slider = new Swiper(this.querySelector('[data-slider]'), this.sliderOptions);
  }
}

customElements.define('search-slider', SearchSlider);
